// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideElementOnPrint } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";
import { pageBreadcrumbStyles } from "@eisinc/Overrides/Components/PageBreadcrumbs";

pageBreadcrumbStyles.breadcrumbs = {
    css: css`
        & {
            padding: 12px 0 16px 0;
            min-height: 42px;
            &:empty {
                display: none;
            }
        }
        ${hideElementOnPrint}
    `,
    mergeCss: true,
};

pageBreadcrumbStyles.breadcrumbsPlaceholder = {
    css: css`
        & {
            height: 10px;
        }
    `,
};
